// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pricing-toggle_labs .v-switch-label{padding-top:.2em !important}.pricing-toggle_labs .v-switch-core{height:2.35em !important}.pricing-toggle_labs .v-switch-core .v-switch-button{top:.18em !important;height:2em !important}", ""]);
// Exports
module.exports = exports;
